import { useQuery } from "@tanstack/react-query";
import { profileService } from "@/services/profileService";

export function useCurrentUser() {
  return useQuery({
    queryKey: ["currentUser"],
    queryFn: profileService.fetchCurrentUser,
    staleTime: 5 * 60 * 1000,
  });
}
